export enum WhatsAppChatAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    UPDATE_WHATS_APP_CHAT_LIST = "UPDATE_WHATS_APP_CHAT_LIST",
    ADD_WHATS_APP_CHAT_LIST = "ADD_WHATS_APP_CHAT_LIST",
    UPDATE_WHATS_APP_CHAT_SEARCH_REQ = "UPDATE_WHATS_APP_CHAT_SEARCH_REQ",
    SET_UPDATE_WHATS_APP_CHAT = "SET_UPDATE_WHATS_APP_CHAT",
}